module.exports = __webpack_public_path__ + "static/media/page-not-found.c572ed90.jpg";